import { DestroyRef, effect, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MetricsClient,
  TaskGroupMetricsResult,
} from '@r1-development/resolution-mechanicalturk-api-client';
import { filter } from 'rxjs';
import { BroadcastChannelService } from '../broadcast-channel/broadcast-channel.service';

@Injectable({ providedIn: 'root' })
export class MetricsService {
  private readonly broadcastChannelService = inject(BroadcastChannelService);
  private readonly metricsClient = inject(MetricsClient);

  private readonly destroyRef = inject(DestroyRef);
  private _userId = signal<string | null>(null);
  private _loadRequest = signal<number>(0);

  constructor() {
    this.initLoader();
  }

  public metricsSignal =
    this.broadcastChannelService.getChannelSignal<TaskGroupMetricsResult | null>(
      BroadcastChannelService.broadcastChannelNames.MyCompletedTasksChannel
    );

  public setUserId(userId: string | null) {
    this._userId.set(userId);
  }

  public loadMetrics() {
    this._loadRequest.set(this._loadRequest() + 1);
  }

  private initLoader() {
    effect(() => {
      if (!this._userId() || !this._loadRequest()) {
        return;
      }
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      const tomorrowStart = new Date(
        todayStart.getTime() + 24 * 60 * 60 * 1000
      );

      this.metricsClient
        .getTaskGroupMetrics(
          null,
          null,
          this._userId(),
          null,
          todayStart,
          tomorrowStart,
          null,
          null,
          null,
          null,
          null,
          null, // specializations not applicable
          null, // serviceLines not applicable
          null // globalEligible not applicable
        )
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter((response) => !!response)
        )
        .subscribe((item: TaskGroupMetricsResult) => {
          // update broadcastChannelSender to message all tabs/windows
          this.broadcastChannelService.postMessageToChannel<TaskGroupMetricsResult | null>(
            BroadcastChannelService.broadcastChannelNames
              .MyCompletedTasksChannel,
            item
          );
        });
    });
  }
}
